import { FormattedMessage, useIntl } from 'react-intl'
import { useEffect } from 'react'
import { LoginButtonWrapper, LoginFormContainer } from '../../styled-components'
import {
  buttonSizeOptions,
  buttonVariantOptions
} from '../../../../components/stories/atoms/button/constants'
import ButtonComponent from '../../../../components/stories/atoms/button'
import TextInputComponent from '../../../../components/stories/molecules/text-input'
import { textInputHintVariantOptions } from '../../../../components/stories/molecules/text-input/constants'
import { useHistory } from 'react-router-dom'
import { useAuthStore } from '../../../../zustand/authentication/use-auth-store.jsx'
import { zodResolver } from '@hookform/resolvers/zod'
import { createSchemas } from './form-schemas.js'
import { useForm } from 'react-hook-form'

const LoginForm = ({
  handleLogin,
  isLoading,
  isInPopup,
  emailVerifying,
  onEmailChange,
  defaultEmail
}) => {
  const history = useHistory()
  const { setShowLoginPopup } = useAuthStore()

  const { formatMessage } = useIntl()

  // Create schemas with internationalization
  const { loginFormSchema } = createSchemas(formatMessage)

  const handleSsoNavigation = () => {
    if (isInPopup) {
      setShowLoginPopup(false)
    }
    history.push('/ssoSelection')
  }

  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
    watch
  } = useForm({
    defaultValues: {
      email: defaultEmail,
      password: ''
    },
    resolver: zodResolver(loginFormSchema),
    mode: 'onTouched'
  })

  // Get form values for validation
  const email = watch('email')
  const password = watch('password')

  // Update parent component's email state when email changes
  useEffect(() => {
    if (onEmailChange && email) {
      onEmailChange(email)
    }
  }, [email, onEmailChange])

  const onSubmit = (data) => isValid && handleLogin(data)

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <LoginFormContainer>
        <TextInputComponent
          label={formatMessage({ id: 'emailAddress' })}
          type="email"
          clearButton={true}
          hintShow={!!errors.email}
          hintVariant={textInputHintVariantOptions.ERROR}
          hintMessage={
            errors.email?.message ||
            formatMessage({
              id: 'invalid_email'
            })
          }
          {...register('email')}
        />

        <TextInputComponent
          label={formatMessage({ id: 'login_page_password' })}
          type="password"
          clearButton={true}
          hintShow={!!errors.password}
          hintVariant={textInputHintVariantOptions.ERROR}
          hintMessage={errors.password?.message}
          {...register('password')}
        />
      </LoginFormContainer>
      <LoginButtonWrapper>
        <ButtonComponent
          fullWidth={true}
          variant={buttonVariantOptions.PRIMARY}
          size={buttonSizeOptions.LARGE}
          type="submit"
          isLoading={isLoading}
          disabled={!isValid || !email || !password || emailVerifying}
        >
          <FormattedMessage id="registerForm_login" />
        </ButtonComponent>
        <ButtonComponent
          type="button"
          onClick={handleSsoNavigation}
          variant={buttonVariantOptions['TERTIARY-HOLLOW']}
          size={buttonSizeOptions.LARGE}
          fullWidth={true}
        >
          <FormattedMessage id="singleSignOn_title" />
        </ButtonComponent>
      </LoginButtonWrapper>
    </form>
  )
}

export default LoginForm
